import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Set to true if badge is attached to content
   */
  isAttached: PropTypes.bool,
  status: PropTypes.oneOf(['default', 'error', 'low-inventory', 'success']),
  theme: PropTypes.oneOf(['', 'loyalty'])
};
function Badge(_ref) {
  var children = _ref.children,
    isAttached = _ref.isAttached,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'default' : _ref$status,
    theme = _ref.theme;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "badge",
    "data-attached": isAttached,
    "data-status": status,
    "data-theme": theme
  }, children);
}
Badge.propTypes = propTypes;

export { Badge as default };
//# sourceMappingURL=Badge.js.map
